import { render, staticRenderFns } from "./UgcReposting.vue?vue&type=template&id=39f4a514"
import script from "./UgcReposting.vue?vue&type=script&lang=js"
export * from "./UgcReposting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports